module.exports = __webpack_public_path__ + "bab6c1570c609cf52d2ddde4a542470e.MP3";